<template>
<div>
</div>
</template>

<script>

export default {
    data() {
        return {
            contact_request_id: '',

            contact_request: {
                'customer_name' : '',
                'contact_request_id' : '',
                'message_from_customer' : '',
                'has_been_contacted' : true,
                'creation_time' : 1600971929992
            },
            
            inbox: {
                'help_with' : '',
            },
        }
    },

    created () {
        this.$event_bus.$on('upsert-contact-request', this.upsertContactRequest);
    },

    beforeDestroy () {
        this.$event_bus.$off('upsert-contact-request',this.upsertContactRequest);
    },

    methods: 
    {
        showDialog(contact_request_id) 
        {
            this.contact_request_id = contact_request_id;

            this.$rc.getContactRequest(
                contact_request_id, 

                (data) => {
                    this.contact_request = data.contact_request;
                    this.inbox = data.inbox;
                    if ( this.contact_request.has_been_contacted ) return;

                    this.$rc.snackbar(this.snackbar_text,6000);
                },

                () => {
                }
            );
        },

        upsertContactRequest(contact_request_id)
        {
            if ( this.snackbar == false ) return;
            if ( this.contact_request.contact_request_id != contact_request_id ) return;
            
            this.$rc.getContactRequest(
                contact_request_id, 

                (data) => {
                    if ( data.contact_request.has_been_contacted ) 
                        this.$rc.closeSnackbar();
                },

                () => {
                }
            );
        },
    },
    
    computed: {
        snackbar_text() {
            
            let cr = this.contact_request;
            let inbox = this.inbox;
            

            if ( inbox != null )
                return cr.customer_name + ' is requesting help with '+ inbox.help_with + '.';

            if ( cr.created_by != null )
            {
                return cr.created_by.full_name + ' has asked you to contact ' + cr.customer_name + '.';
            }
            
            return 'You have a new contact request.'
        }
    },
}
</script>

<style lang="scss" scoped>

</style>